import React, { FC, ReactNode, useCallback, useState } from 'react';
import { Fade } from 'reactstrap';
import { useInterval, useTimeout } from 'utils/util/hooks';

interface Props {
  elements: ReactNode[];
  rotationIntervalInMillis?: number;
  footerElement?: ReactNode;
  footerElementShowAfterMillis?: number;
}

const FadingElementList: FC<Props> = ({
  elements,
  rotationIntervalInMillis = 4000,
  footerElement,
  footerElementShowAfterMillis = 10000,
}) => {
  const [currentElementIdx, setCurrentElementIdx] = useState<number>(0);
  const [footerElementHidden, setFooterElementHidden] = useState<boolean>(true);

  const rotateText = useCallback(() => {
    setCurrentElementIdx((idx) => (idx + 1) % elements.length);
  }, [elements.length]);

  const showFooterElement = useCallback(
    () => setFooterElementHidden(false),
    []
  );

  useInterval(rotateText, rotationIntervalInMillis);
  useTimeout(showFooterElement, footerElementShowAfterMillis);

  return (
    <>
      {elements.map((el, idx) => (
        <Fade
          hidden={idx !== currentElementIdx}
          key={idx}
          in={idx === currentElementIdx}
        >
          <div>{el}</div>
        </Fade>
      ))}
      {!footerElementHidden && footerElement}
    </>
  );
};

export default React.memo(FadingElementList);
